export const CLEAR_LIST_WORK_LOG_BY_DAY = 'CLEAR_LIST_WORK_LOG_BY_DAY'

export const GET_LIST_WORK_LOG_BY_DAY = 'GET_LIST_WORK_LOG_BY_DAY'
export const GET_LIST_WORK_LOG_BY_DAY_FAILED = 'GET_LIST_WORK_LOG_BY_DAY_FAILED'
export const GET_LIST_WORK_LOG_BY_DAY_SUCCESS = 'GET_LIST_WORK_LOG_BY_DAY_SUCCESS'
